function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable indent */
import uuid from 'uuid/v4';
var defaultState = {
  data: [],
  limit: 20,
  offset: 0,
  total: 0,
  error: null,
  isEmpty: false,
  isLoading: false,
  orderBy: {
    field: 'created',
    desc: true
  },
  filter: {
    id: 'all',
    status: null,
    searchTerm: ''
  }
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case 'ORDERS_GET_REQUEST':
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true,
        error: null
      });
    case 'ORDERS_GET_SUCCESS':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: _toConsumableArray(action.orders).map(function (item) {
          return _objectSpread(_objectSpread({
            _lastFetchedByList: new Date(Date.now()).toISOString()
          }, item), {}, {
            signers: item.signers.map(function (signer) {
              return _objectSpread(_objectSpread({}, signer), {}, {
                id: signer.id || uuid()
              });
            }),
            stringified: "\n            title:".concat(item.metaData.title, "\n            status:").concat(item.status, "\n            ").concat(item.signers.map(function (signer) {
              return "signer:".concat(signer.name ? signer.name : signer.email);
            }), "\n            ").concat(item.documents.map(function (doc) {
              return "document:".concat(doc.title);
            }), "\n            ").concat(item.documents.map(function (doc) {
              return "filename:".concat(doc.filename);
            }), "\n            ").concat(item.attachments.map(function (attachment) {
              return "attachment:".concat(attachment.title);
            }), "\n            ").concat(item.attachments.map(function (attachment) {
              return "filename:".concat(attachment.filename);
            }), "\n          ")
          });
        }),
        offset: action.offset,
        total: action.total,
        isLoading: false,
        isEmpty: action.total <= 0 && action.filter.id === 'all' && !action.filter.searchTerm,
        filter: action.filter,
        orderBy: action.orderBy,
        error: null
      });
    case 'ORDERS_GET_FAILURE':
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        error: {
          message: action.message
        }
      });
    case 'ORDER_SAVE':
      return _objectSpread({}, state);
    case 'ORDER_RESTORE_SUCCESS':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: state.data.map(function (order) {
          return order.id === action.order.id ? action.order : order;
        })
      });
    case 'ORDER_CHANGE_DEADLINE_SUCCESS':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: state.data.map(function (order) {
          return order.id === action.order.id ? action.order : order;
        })
      });
    case 'ORDER_GET_SUCCESS':
      return _objectSpread(_objectSpread({}, state), {}, {
        data: state.data.map(function (order) {
          return order.id === action.order.id ? _objectSpread(_objectSpread(_objectSpread({}, order), action.order), {}, {
            _lastFetchedById: new Date(Date.now()).toISOString()
          }) : order;
        })
      });
    default:
      return state;
  }
});